import { render, staticRenderFns } from "./projects-edit.vue?vue&type=template&id=23d6dfd0&scoped=true&"
import script from "./projects-edit.vue?vue&type=script&lang=js&"
export * from "./projects-edit.vue?vue&type=script&lang=js&"
import style0 from "./projects-edit.vue?vue&type=style&index=0&id=23d6dfd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d6dfd0",
  null
  
)

export default component.exports